// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.producthome_products__z9YOA {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 80px;
}

.producthome_container__O1iIi {
  display: flex;
  width: 100%;
  max-width: 1200px;
  gap: 20px;
}

.producthome_right__M6ef-, .producthome_left__hrRQI {
  flex: 1 1;
  min-width: 0;
  position: relative;
}

.producthome_right__M6ef- {
  cursor: pointer;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.producthome_right__M6ef-:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.2);
}

.producthome_right__M6ef-::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: rgba(248, 250, 252, 0.9);
  transform: scaleX(0);
  transition: transform 0.3s ease;
  z-index: 10;
}

.producthome_right__M6ef-:hover::before {
  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);
  transform: scaleX(1);
}

.producthome_cover__OIfe2 {
  width: 100%;
  height: 588px;
  display: block;
  border-radius: 16px;
  object-fit: cover;
  object-position: center 40%;
  transition: transform 0.3s ease;
}

.producthome_right__M6ef-:hover .producthome_cover__OIfe2 {
  transform: scale(1.05);
}

.producthome_playicon__SQcMC {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  transition: all 0.3s ease;
  z-index: 5;
}

.producthome_right__M6ef-:hover .producthome_playicon__SQcMC {
  transform: translate(-50%, -50%) scale(1.2);
}

.producthome_right__M6ef- .producthome_title__UNWTN {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  text-align: center;
  color: #1a5f3f;
  background: linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(226, 232, 240, 0.95) 100%);
  border-radius: 16px;
  padding: 12px 16px;
  transition: all 0.3s ease;
  backdrop-filter: blur(15px);
  font-weight: 700;
  font-size: 16px;
  line-height: 1.4;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.producthome_right__M6ef- .producthome_title__UNWTN span {
  color: #1a5f3f;
  transition: color 0.3s ease;
  font-weight: 600;
}

.producthome_right__M6ef-:hover .producthome_title__UNWTN {
  color: white;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(26, 95, 63, 0.3);
}

.producthome_right__M6ef-:hover .producthome_title__UNWTN span {
  color: white;
}

.producthome_left__hrRQI .producthome_subtitle__hzX7f {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  text-align: center;
  color: #1a5f3f;
  background: linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(226, 232, 240, 0.95) 100%);
  border-radius: 16px;
  padding: 12px 16px;
  transition: all 0.3s ease;
  backdrop-filter: blur(15px);
  font-weight: 700;
  font-size: 14px;
  line-height: 1.4;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.producthome_left__hrRQI .producthome_subtitle__hzX7f span {
  color: #1a5f3f;
  transition: color 0.3s ease;
  font-weight: 600;
}

.producthome_left__hrRQI {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.producthome_left__hrRQI .producthome_subproduct__hm\\+iv {
  flex: 45% 1;
  position: relative;
  cursor: pointer;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.producthome_left__hrRQI .producthome_subproduct__hm\\+iv:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(26, 95, 63, 0.15);
}

.producthome_left__hrRQI .producthome_subproduct__hm\\+iv::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: rgba(248, 250, 252, 0.9);
  transform: scaleX(0);
  transition: transform 0.3s ease;
  z-index: 5;
}

.producthome_left__hrRQI .producthome_subproduct__hm\\+iv:hover::before {
  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);
  transform: scaleX(1);
}

/* Left side play icon - smaller version */
.producthome_playiconleft__yEwdR {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease;
  z-index: 5;
}

.producthome_playiconleft__yEwdR img{
  width: 60px;
}

.producthome_left__hrRQI .producthome_subproduct__hm\\+iv:hover .producthome_playiconleft__yEwdR {
  transform: translate(-50%, -50%) scale(1.2);
}

.producthome_left__hrRQI .producthome_subproduct__hm\\+iv:hover .producthome_subtitle__hzX7f {
  color: white;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(26, 95, 63, 0.3);
}

.producthome_left__hrRQI .producthome_subproduct__hm\\+iv:hover .producthome_subtitle__hzX7f span {
  color: white;
}

.producthome_left__hrRQI .producthome_subcover__vup1Q {
  width: 100%;
  height: 180px;
  border-radius: 16px;
  transition: transform 0.3s ease;
}

.producthome_left__hrRQI .producthome_subproduct__hm\\+iv:hover .producthome_subcover__vup1Q {
  transform: scale(1.05);
}

/* Responsive */
@media (max-width: 768px) {
  .producthome_container__O1iIi {
    flex-direction: column;
  }
  
  .producthome_right__M6ef-, .producthome_left__hrRQI {
    order: initial; 
    width: 100%;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .producthome_container__O1iIi, .producthome_container-md__LDkJX {
    max-width: 720px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .producthome_container__O1iIi, .producthome_container-lg__64Ulr {
    max-width: 960px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .producthome_container__O1iIi, .producthome_container-xl__rt-aw {
    max-width: 1140px;
  }
}

/* XX-Large devices (larger desktops, 1400px and up) */
@media (min-width: 1400px) {
  .producthome_container__O1iIi, .producthome_container-xxl__yZ3Qx {
    max-width: 1320px;
  }
}

/* XXX-Large devices (extra large desktops, 1600px and up) */
@media (min-width: 1600px) {
  .producthome_container__O1iIi, .producthome_container-xxxl__Z8b9m {
    max-width: 1500px;
  }
}

/* 4K and larger displays (1920px and up) */
@media (min-width: 1920px) {
  .producthome_container__O1iIi, .producthome_container-4k__m55SO {
    max-width: 1550px;
  }
}


.producthome_stateBox__qX3S0 {
    width: 100%;
    min-height: 260px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin: 20px 0 80px;
    padding: 24px;
    border-radius: 18px;
    background: linear-gradient(135deg, #f8fcfa 0%, #edf8f2 100%);
    border: 1px solid rgba(1, 89, 51, 0.12);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
}

.producthome_stateText__v1Ha1 {
    font-size: 15px;
    font-weight: 600;
    color: #02301c;
    text-align: center;
    margin: 0;
    line-height: 1.6;
}

.producthome_loader__RXH8J {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 4px solid rgba(1, 89, 51, 0.12);
    border-top-color: #015933;
    animation: producthome_spin__SIoFU 0.9s linear infinite;
}

@keyframes producthome_spin__SIoFU {
    to {
        transform: rotate(360deg);
    }
}

@media (max-width: 768px) {
    .producthome_stateBox__qX3S0 {
        min-height: 220px;
        margin-bottom: 60px;
        padding: 20px;
    }

    .producthome_stateText__v1Ha1 {
        font-size: 14px;
    }

    .producthome_loader__RXH8J {
        width: 40px;
        height: 40px;
        border-width: 3px;
    }
}

@media (max-width: 480px) {
    .producthome_stateBox__qX3S0 {
        min-height: 180px;
        margin-bottom: 50px;
        padding: 18px;
        border-radius: 14px;
    }

    .producthome_stateText__v1Ha1 {
        font-size: 13px;
    }

    .producthome_loader__RXH8J {
        width: 34px;
        height: 34px;
        border-width: 3px;
    }
}`, "",{"version":3,"sources":["webpack://./src/website/Home/producthome.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oCAAoC;EACpC,oBAAoB;EACpB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,iGAAiG;EACjG,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,iGAAiG;EACjG,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAS;EACT,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oCAAoC;EACpC,oBAAoB;EACpB,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,sDAAsD;AACtD;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,6DAA6D;IAC7D,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,yBAAyB;IACzB,uDAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;AACJ","sourcesContent":[".products {\r\n  display: flex;\r\n  justify-content: center;\r\n  width: 100%;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n  margin-bottom: 80px;\r\n}\r\n\r\n.container {\r\n  display: flex;\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  gap: 20px;\r\n}\r\n\r\n.right, .left {\r\n  flex: 1;\r\n  min-width: 0;\r\n  position: relative;\r\n}\r\n\r\n.right {\r\n  cursor: pointer;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.right:hover {\r\n  transform: translateY(-8px);\r\n  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.2);\r\n}\r\n\r\n.right::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 4px;\r\n  background: rgba(248, 250, 252, 0.9);\r\n  transform: scaleX(0);\r\n  transition: transform 0.3s ease;\r\n  z-index: 10;\r\n}\r\n\r\n.right:hover::before {\r\n  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);\r\n  transform: scaleX(1);\r\n}\r\n\r\n.cover {\r\n  width: 100%;\r\n  height: 588px;\r\n  display: block;\r\n  border-radius: 16px;\r\n  object-fit: cover;\r\n  object-position: center 40%;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.right:hover .cover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.playicon {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 60px;\r\n  height: 60px;\r\n  transition: all 0.3s ease;\r\n  z-index: 5;\r\n}\r\n\r\n.right:hover .playicon {\r\n  transform: translate(-50%, -50%) scale(1.2);\r\n}\r\n\r\n.right .title {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  left: 0;\r\n  right: 0;\r\n  text-align: center;\r\n  color: #1a5f3f;\r\n  background: linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(226, 232, 240, 0.95) 100%);\r\n  border-radius: 16px;\r\n  padding: 12px 16px;\r\n  transition: all 0.3s ease;\r\n  backdrop-filter: blur(15px);\r\n  font-weight: 700;\r\n  font-size: 16px;\r\n  line-height: 1.4;\r\n  border: 1px solid rgba(255, 255, 255, 0.3);\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.right .title span {\r\n  color: #1a5f3f;\r\n  transition: color 0.3s ease;\r\n  font-weight: 600;\r\n}\r\n\r\n.right:hover .title {\r\n  color: white;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 8px 20px rgba(26, 95, 63, 0.3);\r\n}\r\n\r\n.right:hover .title span {\r\n  color: white;\r\n}\r\n\r\n.left .subtitle {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  left: 0;\r\n  right: 0;\r\n  text-align: center;\r\n  color: #1a5f3f;\r\n  background: linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(226, 232, 240, 0.95) 100%);\r\n  border-radius: 16px;\r\n  padding: 12px 16px;\r\n  transition: all 0.3s ease;\r\n  backdrop-filter: blur(15px);\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  border: 1px solid rgba(255, 255, 255, 0.3);\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.left .subtitle span {\r\n  color: #1a5f3f;\r\n  transition: color 0.3s ease;\r\n  font-weight: 600;\r\n}\r\n\r\n.left {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n}\r\n\r\n.left .subproduct {\r\n  flex: 45%;\r\n  position: relative;\r\n  cursor: pointer;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.left .subproduct:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 8px 20px rgba(26, 95, 63, 0.15);\r\n}\r\n\r\n.left .subproduct::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: rgba(248, 250, 252, 0.9);\r\n  transform: scaleX(0);\r\n  transition: transform 0.3s ease;\r\n  z-index: 5;\r\n}\r\n\r\n.left .subproduct:hover::before {\r\n  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);\r\n  transform: scaleX(1);\r\n}\r\n\r\n/* Left side play icon - smaller version */\r\n.playiconleft {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  transition: all 0.3s ease;\r\n  z-index: 5;\r\n}\r\n\r\n.playiconleft img{\r\n  width: 60px;\r\n}\r\n\r\n.left .subproduct:hover .playiconleft {\r\n  transform: translate(-50%, -50%) scale(1.2);\r\n}\r\n\r\n.left .subproduct:hover .subtitle {\r\n  color: white;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 8px 20px rgba(26, 95, 63, 0.3);\r\n}\r\n\r\n.left .subproduct:hover .subtitle span {\r\n  color: white;\r\n}\r\n\r\n.left .subcover {\r\n  width: 100%;\r\n  height: 180px;\r\n  border-radius: 16px;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.left .subproduct:hover .subcover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .container {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .right, .left {\r\n    order: initial; \r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* Medium devices (tablets, 768px and up) */\r\n@media (min-width: 768px) {\r\n  .container, .container-md {\r\n    max-width: 720px;\r\n  }\r\n}\r\n\r\n/* Large devices (desktops, 992px and up) */\r\n@media (min-width: 992px) {\r\n  .container, .container-lg {\r\n    max-width: 960px;\r\n  }\r\n}\r\n\r\n/* Extra large devices (large desktops, 1200px and up) */\r\n@media (min-width: 1200px) {\r\n  .container, .container-xl {\r\n    max-width: 1140px;\r\n  }\r\n}\r\n\r\n/* XX-Large devices (larger desktops, 1400px and up) */\r\n@media (min-width: 1400px) {\r\n  .container, .container-xxl {\r\n    max-width: 1320px;\r\n  }\r\n}\r\n\r\n/* XXX-Large devices (extra large desktops, 1600px and up) */\r\n@media (min-width: 1600px) {\r\n  .container, .container-xxxl {\r\n    max-width: 1500px;\r\n  }\r\n}\r\n\r\n/* 4K and larger displays (1920px and up) */\r\n@media (min-width: 1920px) {\r\n  .container, .container-4k {\r\n    max-width: 1550px;\r\n  }\r\n}\r\n\r\n\r\n.stateBox {\r\n    width: 100%;\r\n    min-height: 260px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 16px;\r\n    margin: 20px 0 80px;\r\n    padding: 24px;\r\n    border-radius: 18px;\r\n    background: linear-gradient(135deg, #f8fcfa 0%, #edf8f2 100%);\r\n    border: 1px solid rgba(1, 89, 51, 0.12);\r\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.stateText {\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    color: #02301c;\r\n    text-align: center;\r\n    margin: 0;\r\n    line-height: 1.6;\r\n}\r\n\r\n.loader {\r\n    width: 48px;\r\n    height: 48px;\r\n    border-radius: 50%;\r\n    border: 4px solid rgba(1, 89, 51, 0.12);\r\n    border-top-color: #015933;\r\n    animation: spin 0.9s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .stateBox {\r\n        min-height: 220px;\r\n        margin-bottom: 60px;\r\n        padding: 20px;\r\n    }\r\n\r\n    .stateText {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .loader {\r\n        width: 40px;\r\n        height: 40px;\r\n        border-width: 3px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .stateBox {\r\n        min-height: 180px;\r\n        margin-bottom: 50px;\r\n        padding: 18px;\r\n        border-radius: 14px;\r\n    }\r\n\r\n    .stateText {\r\n        font-size: 13px;\r\n    }\r\n\r\n    .loader {\r\n        width: 34px;\r\n        height: 34px;\r\n        border-width: 3px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"products": `producthome_products__z9YOA`,
	"container": `producthome_container__O1iIi`,
	"right": `producthome_right__M6ef-`,
	"left": `producthome_left__hrRQI`,
	"cover": `producthome_cover__OIfe2`,
	"playicon": `producthome_playicon__SQcMC`,
	"title": `producthome_title__UNWTN`,
	"subtitle": `producthome_subtitle__hzX7f`,
	"subproduct": `producthome_subproduct__hm+iv`,
	"playiconleft": `producthome_playiconleft__yEwdR`,
	"subcover": `producthome_subcover__vup1Q`,
	"container-md": `producthome_container-md__LDkJX`,
	"container-lg": `producthome_container-lg__64Ulr`,
	"container-xl": `producthome_container-xl__rt-aw`,
	"container-xxl": `producthome_container-xxl__yZ3Qx`,
	"container-xxxl": `producthome_container-xxxl__Z8b9m`,
	"container-4k": `producthome_container-4k__m55SO`,
	"stateBox": `producthome_stateBox__qX3S0`,
	"stateText": `producthome_stateText__v1Ha1`,
	"loader": `producthome_loader__RXH8J`,
	"spin": `producthome_spin__SIoFU`
};
export default ___CSS_LOADER_EXPORT___;
